export const SignUpData = [
  { url: "https://www.google.com/", icon: "google" ,color:"danger"},
  { url: "https://twitter.com/", icon: "twitter" ,color:"primary"},
  { url: "https://www.facebook.com/", icon: "facebook-f" ,color:"facebook"},
];
